import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./CategoriesPage.module.css";
import logo from "../../assets/images/LightLogo.webp";
import { HiArrowLeft } from "react-icons/hi2";
import {
  selectCategoriesData,
  selectCategoriesLoading,
} from "../../redux/slices/categoriesSlice";
import { fetchCategories } from "../../redux/actions/categoriesActions";
import { useNavigate } from "react-router";
import { AppDispatch } from "../../redux/store";

const CategoriesPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const categoriesData = useSelector(selectCategoriesData);
  const loading = useSelector(selectCategoriesLoading);
  const navigate = useNavigate();

  useEffect(() => {
    if (categoriesData.content.length === 0) {
      dispatch(fetchCategories());
    }
  }, [dispatch, categoriesData.content.length]);

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/lajmet?category=${categoryId}`);
  };

  return (
    <div className={classes.mainDiv}>
      <div className={classes.header}>
        <div className={classes.backRow} onClick={() => navigate("/lajmet")}>
          <div className={classes.circleButton}>
            <HiArrowLeft fontSize="1.2rem" color="white" />
          </div>
          <span className={classes.backText}>Rikthehu ne faqe</span>
        </div>

        <div className={classes.centerBlock}>
          <img src={logo} alt="logo" className={classes.centerLogo} />
          <h2 className={classes.headerTitle}>
            Selektoni kategoritë e preferuara
          </h2>
        </div>
      </div>
      <div className={classes.content}>
        {loading ? (
          <div className={classes.grid}>
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className={classes.skeletonCard}>
                <div className={classes.skeletonTitle} />
              </div>
            ))}
          </div>
        ) : (
          <div className={classes.grid}>
            {categoriesData.content.slice(0, 6).map((category) => (
              <div
                key={category.id}
                className={classes.card}
                onClick={() => handleCategoryClick(category.id)}
                role="button"
                tabIndex={0}
              >
                <img
                  src={category.categoryImage}
                  alt={category.name}
                  loading="lazy"
                />
                <span className={classes.cardTitle}>{category.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriesPage;
